import { useEffect, useState } from 'react'
import Container from '../../../../../constants/Container';
import SecHeading from '../../../../../constants/SecHeading';
import { debounce, Grid } from '@mui/material';
import InputTextBox from '../../../../../constants/InputTextBox';
import { memterStatusOptions, SearchMemberListMahasulOptions } from '../../../../../constants/Options';
import { useFormik } from 'formik';
import RadioButton from '../../../../../constants/RadioBtn';
import { EndBaseLine } from '../../../../../constants/AppSpace';
import { Button } from '../../../../../constants/Button';
import SelectInputBox from '../../../../../constants/SelectInputBox';
import { handleChangeDate } from '../../../../../helpers/handleChange';
import useFetchSubData from '../../../../../helpers/useSubFetch';
import AppURL from '../../../../../constants/AppURL';
import { CiCalendarDate } from 'react-icons/ci';
import { BSToADUSFormat, NepNowDateFormat } from '../../../../../constants/DateFormat';
import { postDataToTheServer } from '../../../../../helpers/api';
import { ToastSuccess, ToastWarning } from '../../../../../constants/Toast';
import { mahasulEntryListDateWise } from '../../../../../helpers/submitDataOnServer';
import { useDispatch } from 'react-redux';

const EntryFormView = () => {
    const [onSearchMem, setOnSearchMem] = useState("");
    const dispatch = useDispatch();
    const handleSelect = debounce((value) => {
        setOnSearchMem(value);
    }, 300); 
    const date_ne = NepNowDateFormat();
    const { data: member_data, loading: part_loading, error: part_error, refetch } = useFetchSubData(`${AppURL.FrontOfficeURL}front/mahasul/entry/customer/all/list/view/?search=${onSearchMem}`, onSearchMem || 'a');
    const searchMemberListOptions = SearchMemberListMahasulOptions(member_data?.customers?.results);
    const initialValues = {
        tole_name: "",
        tap_size_name: "",
        prev_unit: "",
        tap_size_id: 0,
        date_e: "",
        date_n: date_ne || "",
        member_sn: "",
        monthh: "",
        yearr: "",
        mem_id: "",
        unit_total: "",
        consume_unit: "",
        consume_amt: "",
        meter_status: "",
        reader: "",
        current_unit: "",
    };

    const { values, errors, touched, setFieldValue, isSubmitting, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues,
        enableReinitialize: true,
        onSubmit: async (values, action) => {
            const formData = new FormData();
            formData.append("date_n", values.date_n);
            const [year, month] = values.date_n?.split('/');
            formData.append("monthh", month);
            formData.append("yearr", year);
            formData.append("date_e", BSToADUSFormat(values.date_n));
            formData.append("member_sn", values.member_sn);
            formData.append("mem_id", values.member_sn);
            const consumeUnit = values.consume_unit ? parseFloat(values.consume_unit) : 0;
            const prevUnit = values.prev_unit ? parseFloat(values.prev_unit) : 0;
            const unitTotal = consumeUnit + prevUnit;
            formData.append("unit_total", unitTotal.toString());
            formData.append("consume_unit", values.consume_unit || "0");
            formData.append("consume_amt", values.consume_amt || "0");
            formData.append("meter_status", values.meter_status);
            formData.append("reader", values.reader);
            if (parseFloat(values.consume_unit || "0") >= 0) {
                try {
                    await postDataToTheServer(AppURL.TapsURL + 'account/manage/unit/create/view/', formData).then((res) => {
                        if (res?.status === 201) {
                            ToastSuccess({ message: res?.message });
                            refetch();
                            action.resetForm();
                        } else if (res?.status === 400) {
                            ToastWarning({ message: res?.response?.data?.message });
                        } else {
                        }
                    });
                } catch (error) {
                    console.log(error);
                }
            } else {
                ToastWarning({ message: "Check your consume unit" });
            }
        },
    });


    useEffect(() => {
        if (!Array.isArray(member_data?.unit_rate)) return;
        const currentUnit = parseFloat(values.current_unit || "0");
        const prevUnit = parseFloat(values.prev_unit || "0");
        const totConsumeUnit = currentUnit - prevUnit;
        setFieldValue("consume_unit", totConsumeUnit || "0");
    }, [values?.tap_size_id, setFieldValue, member_data, values.consume_unit, values.current_unit, values.prev_unit]);

    const fetchDateWiseMahasul = async () => {
        await mahasulEntryListDateWise(dispatch, `${AppURL.TapsURL}account/manage/unit/list/view/?date_e=${BSToADUSFormat(values.date_n)}`)
    }
    return (
        <Container padding={true}>
            <form onSubmit={handleSubmit}>
                <SecHeading type='add' label='Mahasul Entry' />
                <Grid container columnSpacing={3} rowSpacing={0.8}>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            prefix={<CiCalendarDate />}
                            handleChange={(e) => handleChangeDate(e, { setFieldValue, name: 'date_n' })}
                            label='Date(B.S.)'
                            name='date_n'
                            handleBlur={handleBlur}
                            value={values.date_n}
                            error={typeof errors.date_n === 'string' ? errors.date_n : undefined}
                            touched={!!touched.date_n}
                            placeholder='XXXX/XX/XX'
                            required={false}
                        />

                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <SelectInputBox
                            label='Member Search'
                            optionSelect={(name, selectedOption) => {
                                setFieldValue("tole_name", selectedOption.marga_name);
                                setFieldValue("prev_unit", selectedOption.prev_unit);
                                setFieldValue("reader", selectedOption.reader);
                                setFieldValue("tap_size_name", selectedOption.tap_size_name);
                                setFieldValue("tap_size_id", selectedOption.tap_size_id);
                                setFieldValue(name, selectedOption.value);
                            }}
                            options={searchMemberListOptions}
                            value={values.member_sn}
                            required={true}
                            isLoading={part_loading}
                            placeholder='Select Members'
                            name='member_sn'
                            debouncedHandleInputChange={handleSelect}
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='tole_name'
                            label='Address'
                            handleChange={handleChange}
                            value={values.tole_name || ""}
                            error={errors.tole_name}
                            handleBlur={handleBlur}
                            touched={touched.tole_name}
                            required={true}
                            disabled={true}
                            placeholder='Your Tole Name'
                        />
                    </Grid>
                    <Grid item xl={6} lg={6} sm={6} md={6} xs={12}>
                        <InputTextBox
                            type='text'
                            name='tap_size_name'
                            label='Tap Size'
                            handleChange={handleChange}
                            value={values.tap_size_name || ""}
                            error={errors.tap_size_name}
                            handleBlur={handleBlur}
                            touched={touched.tap_size_name}
                            required={true}
                            disabled={true}
                            placeholder='2081-2082'
                        />
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <div className='bg-gray-100 px-1 py-1 rounded-md'>
                            <div className='border border-gray-200 border-dashed px-2 rounded-md'>
                                <RadioButton
                                    options={memterStatusOptions}
                                    name="meter_status"
                                    selectedValue={values.meter_status}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                    </Grid>
                    <Grid item xl={6} lg={6} sm={12} md={6} xs={12}>
                        <Grid container columnSpacing={3} rowSpacing={0.8}>
                            <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                                <InputTextBox
                                    type='text'
                                    name='prev_unit'
                                    label='Previous Unit'
                                    handleChange={handleChange}
                                    value={values.prev_unit || "0"}
                                    error={errors.prev_unit}
                                    handleBlur={handleBlur}
                                    touched={touched.prev_unit}
                                    required={true}
                                    disabled={true}
                                    placeholder='0.0'
                                />
                            </Grid>
                            <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                                <InputTextBox
                                    type='number'
                                    name='current_unit'
                                    label='Current Unit'
                                    handleChange={handleChange}
                                    value={values.current_unit}
                                    error={errors.current_unit}
                                    handleBlur={handleBlur}
                                    touched={touched.current_unit}
                                    required={true}
                                    disabled={false}
                                    placeholder='0'
                                />
                            </Grid>
                            <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                                <InputTextBox
                                    type='text'
                                    name='consume_unit'
                                    label='Consumer Unit'
                                    handleChange={handleChange}
                                    value={values.current_unit ? values.consume_unit : "0"}
                                    error={errors.consume_unit}
                                    handleBlur={handleBlur}
                                    touched={touched.consume_unit}
                                    required={true}
                                    disabled={true}
                                    placeholder='0.0'
                                />
                            </Grid>
                        </Grid>

                    </Grid>
                    <Grid item xl={6} lg={6} sm={12} md={6} xs={12}>
                        <Grid container columnSpacing={3} rowSpacing={0.8}>
                            <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                                <InputTextBox
                                    type='text'
                                    name='reader'
                                    label='Reader ID'
                                    handleChange={handleChange}
                                    value={values.reader}
                                    error={errors.reader}
                                    handleBlur={handleBlur}
                                    touched={touched.reader}
                                    required={true}
                                    disabled={true}
                                    placeholder='-'
                                />
                            </Grid>
                            {/* <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                                <InputTextBox
                                    type='text'
                                    name='current_unit'
                                    label='Current Unit'
                                    handleChange={handleChange}
                                    value={values.current_unit}
                                    error={errors.current_unit}
                                    handleBlur={handleBlur}
                                    touched={touched.current_unit}
                                    required={true}
                                    disabled={true}
                                    placeholder='2081-2082'
                                />
                            </Grid> */}
                            <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                                <InputTextBox
                                    type='text'
                                    name='consume_amt'
                                    label='Total Amount'
                                    handleChange={handleChange}
                                    value={values.consume_amt || ""}
                                    error={errors.consume_amt}
                                    handleBlur={handleBlur}
                                    touched={touched.consume_amt}
                                    required={true}
                                    disabled={false}
                                    placeholder='0.0'
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                        <EndBaseLine top={18} >
                            <Button btn_type='list' onClick={fetchDateWiseMahasul} type='button' el='button' />
                            <Button btn_type='save' type='submit' el='button' loading={isSubmitting} />
                        </EndBaseLine>
                    </Grid>
                </Grid>
            </form>
        </Container>
    )
}

export default EntryFormView